import api from '../api'

const baseUrl = '/academy/api/AdminTeacher'

const dadbanTeacherProvider = {
  getAllTeachers(params = {}) {
    return api.post(`${baseUrl}/Table`, {
      params,
    })
  },

  getTeacher(params) {
    return api.get(`${baseUrl}/Get/${params}`)
  },

  addTeacher(params) {
    return api.post(`${baseUrl}/Add`, params)
  },

  updateTeacher(params = {}) {
    return api.put(`${baseUrl}/Edit`, params)
  },

  deleteTeacher(params) {
    return api.delete(`${baseUrl}/Delete/${params}`)
  },
}

export default dadbanTeacherProvider
